/**
 * App URLS
 */
export const urls = {
	api: 'https://alamo-marketing.azurewebsites.net/api/product/coa',
	img: 'https://alamo-botanicals-shop.imgix.net/',
	pdf: 'https://marketingstoreimages.blob.core.windows.net/labreports/'
};

/**
 * Get COA by Product ID
 */
export async function getCOAs() {
	const response = await fetch(
		'https://api.airtable.com/v0/app8zqNdNJ7qqNsp5/Lab%20Results?maxRecords=1200&view=Grid%20view',
		{
			method: 'GET',
			headers: {
				cookie: 'brw=brwyY8qHJEP244Zpl',
				Authorization: 'Bearer keyQ9uo6Eh5pw5Fuc'
			}
		}
	);
	return response.json();
}
